import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        defaultNS: 'translation',
        debug: true,
        supportedLngs: ['en', 'fr'],
        load: 'languageOnly',
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage']
        },
        resources: {
            en: { translation: translationEN },
            fr: { translation: translationFR }
        },
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }

    });

export default i18n;
